var initGscsArticleShadow;
(function() {
	if(!document.getElementById('article-shadow-host')) return false;

	initGscsArticleShadow = function() {
		var host = document.getElementById('article-shadow-host'),
			source = document.getElementById('gscs-article-html'),
			wrongJs = '/lg4-common-gp/js/global/global.main.d75e0925.js',
			articleHtml,
			shadowRoot,
			parsedDoc,
			links,
			styles,
			scripts,
			anchors,
			bodyClone,
			skipNodes,
			contentRoot,
			i;

		var resolveResourceUrl = function(href) {
			try {
				return new URL(href, window.location.href).href;
			} catch (e) {
				return href;
			}
		};

		var isFontStylesheetHref = function(href) {
			return /cdn\.jsdelivr\.net\/npm\/bootstrap|fonts\.googleapis\.com|fonts\.gstatic\.com/i.test(href);
		};

		var ensureDocumentFontStylesheet = function(href) {
			var resolved = resolveResourceUrl(href);
			var existing = document.querySelectorAll('link[rel="stylesheet"]');
			var alreadyLinked = false;
			var n, link;
			for (n = 0; n < existing.length; n++) {
				link = existing[n];
				if (link.href === resolved || link.getAttribute('href') === href) {
					alreadyLinked = true;
					break;
				}
			}
			if (alreadyLinked) return;

			link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = resolved;
			link.setAttribute('data-article-font', '');
			document.head.appendChild(link);
		};

		var isFontAwesomeScriptSrc = function(src) {
			return /use\.fontawesome\.com|kit\.fontawesome\.com/i.test(src);
		};

		var isFontAwesomeStyleNode = function(node) {
			if (node.tagName === 'LINK') {
				return /font-?awesome|use\.fontawesome|kit\.fontawesome/i.test(node.href || '');
			}
			if (node.tagName === 'STYLE') {
				return /font-?awesome|\.fa[- :]|Font Awesome/i.test(node.textContent || '');
			}
			return false;
		};

		var fontAwesomeScriptLoads = {};
		var fontAwesomeStyleObserver = null;
		var fontAwesomeStyleTimeout = null;

		var copyFontAwesomeStylesToShadow = function(root) {
			var nodes = document.querySelectorAll('link[rel="stylesheet"], style');
			var n, node, already, shadowLinks, shadowStyles, s, clone;
			for (n = 0; n < nodes.length; n++) {
				node = nodes[n];
				if (!isFontAwesomeStyleNode(node)) continue;

				if (node.tagName === 'LINK') {
					already = false;
					shadowLinks = root.querySelectorAll('link[rel="stylesheet"]');
					for (s = 0; s < shadowLinks.length; s++) {
						if (shadowLinks[s].href === node.href) {
							already = true;
							break;
						}
					}
					if (already) continue;
				} else {
					already = false;
					shadowStyles = root.querySelectorAll('style[data-article-fontawesome]');
					for (s = 0; s < shadowStyles.length; s++) {
						if (shadowStyles[s].textContent === node.textContent) {
							already = true;
							break;
						}
					}
					if (already) continue;
				}

				clone = document.importNode(node, true);
				clone.setAttribute('data-article-fontawesome', '');
				root.appendChild(clone);
			}
		};

		var syncFontAwesomeStylesIntoShadow = function(root) {
			if (fontAwesomeStyleObserver) fontAwesomeStyleObserver.disconnect();
			if (fontAwesomeStyleTimeout) window.clearTimeout(fontAwesomeStyleTimeout);

			copyFontAwesomeStylesToShadow(root);

			fontAwesomeStyleObserver = new MutationObserver(function() {
				copyFontAwesomeStylesToShadow(root);
			});
			fontAwesomeStyleObserver.observe(document.head, { childList: true, subtree: true });
			fontAwesomeStyleTimeout = window.setTimeout(function() {
				if (fontAwesomeStyleObserver) fontAwesomeStyleObserver.disconnect();
				fontAwesomeStyleObserver = null;
				fontAwesomeStyleTimeout = null;
			}, 4000);
		};

		var loadFontAwesomeScript = function(src, onSuccess, onError) {
			var resolved = resolveResourceUrl(src);
			var existingScripts = document.querySelectorAll('script[src]');
			var existing = null;
			var n, scriptEl;

			if (fontAwesomeScriptLoads[resolved] === 'loaded') {
				onSuccess();
				return;
			}

			for (n = 0; n < existingScripts.length; n++) {
				if (existingScripts[n].src === resolved || existingScripts[n].getAttribute('src') === src) {
					existing = existingScripts[n];
					break;
				}
			}

			if (existing) {
				existing.addEventListener('load', function() {
					fontAwesomeScriptLoads[resolved] = 'loaded';
					onSuccess();
				});
				fontAwesomeScriptLoads[resolved] = 'loaded';
				onSuccess();
				return;
			}

			fontAwesomeScriptLoads[resolved] = 'loading';
			scriptEl = document.createElement('script');
			scriptEl.src = resolved;
			scriptEl.setAttribute('data-article-fontawesome', '');
			scriptEl.addEventListener('load', function() {
				fontAwesomeScriptLoads[resolved] = 'loaded';
				onSuccess();
			});
			scriptEl.addEventListener('error', function() {
				fontAwesomeScriptLoads[resolved] = 'error';
				console.error('Shadow Font Awesome script failed');
				if (onError) onError();
			});
			document.head.appendChild(scriptEl);
		};

		var aliasBodySelectors = function(css) {
			return css.replace(/(^|[\s,{>+~;(])body(?=[\s,{.#[:+>~)]|$)/gm, '$1.help-article-content');
		};

		var parseSrcDoc = function(decodedHtml) {
			var htmlDoc = new DOMParser().parseFromString('<!doctype html>' + decodedHtml, 'text/html');
			if(!htmlDoc.documentElement || !htmlDoc.documentElement.outerHTML) return decodedHtml;

			var articleContentHTML = htmlDoc.documentElement.outerHTML.replace(/"/g, '&#34;');
			articleContentHTML = articleContentHTML
				.replace('<title />', '<title></title>')
				.replace('<title/>', '<title></title>');

			var holder = document.createElement('div');
			holder.innerHTML = '<iframe srcdoc="' + articleContentHTML + '"></iframe>';
			var iframe = holder.querySelector('iframe');
			return (iframe && iframe.srcdoc) ? iframe.srcdoc : decodedHtml;
		};

		var parseArticleHtmlDocument = function(decodedHtml) {
			return new DOMParser().parseFromString(parseSrcDoc(decodedHtml), 'text/html');
		};

		var articleScriptScopes = new WeakMap();
		var articleWindowLocals = new WeakMap();
		var boundTabShadowRoots = new WeakSet();
		var isolatedWindowKeys = { bootstrap: true, jQuery: true, $: true, Popper: true };
		var pageWindowGlobals = null;

		var snapshotPageWindowGlobals = function() {
			if (pageWindowGlobals) return;
			pageWindowGlobals = {
				bootstrap: window.bootstrap,
				jQuery: window.jQuery,
				$: window.$,
				Popper: window.Popper
			};
		};

		var restorePageWindowGlobals = function() {
			var key;
			if (!pageWindowGlobals) return;
			for (key in isolatedWindowKeys) {
				if (!Object.prototype.hasOwnProperty.call(isolatedWindowKeys, key)) continue;
				if (typeof pageWindowGlobals[key] === 'undefined') {
					try { delete window[key]; } catch (e) { window[key] = undefined; }
				} else {
					window[key] = pageWindowGlobals[key];
				}
			}
		};
		var tabToggleSelector =
			'[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"], [data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';

		var getArticleScriptScope = function(root) {
			var scope = articleScriptScopes.get(root);
			if (!scope) {
				scope = {};
				articleScriptScopes.set(root, scope);
			}
			return scope;
		};

		var getArticleWindowLocals = function(root) {
			var locals = articleWindowLocals.get(root);
			if (!locals) {
				locals = {};
				articleWindowLocals.set(root, locals);
			}
			return locals;
		};

		var resolveTabPanel = function(root, trigger) {
			var raw = trigger.getAttribute('data-bs-target') || trigger.getAttribute('data-target') || trigger.getAttribute('href') || '';
			var hashIndex, selector;
			if (!raw || raw === '#') return null;
			hashIndex = raw.indexOf('#');
			selector = hashIndex >= 0 ? raw.slice(hashIndex) : raw;
			try {
				return root.querySelector(selector);
			} catch (e) {
				return null;
			}
		};

		var activateShadowTabFallback = function(root, trigger) {
			var panel = resolveTabPanel(root, trigger);
			var nav = trigger.closest ? trigger.closest('.nav, [role="tablist"], .list-group') : null;
			var triggers = nav ? nav.querySelectorAll(tabToggleSelector) : [trigger];
			var n, el, isCurrent, panes, pane, parent, children;

			for (n = 0; n < triggers.length; n++) {
				el = triggers[n];
				isCurrent = el === trigger;
				if (isCurrent) el.classList.add('active');
				else el.classList.remove('active');
				if (el.getAttribute('role') === 'tab') {
					el.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
					if (isCurrent) el.removeAttribute('tabindex');
					else el.setAttribute('tabindex', '-1');
				}
			}

			if (!panel) return;
			parent = panel.parentElement;
			panes = [];
			if (parent) {
				children = parent.children;
				for (n = 0; n < children.length; n++) {
					if (children[n].classList && children[n].classList.contains('tab-pane')) panes.push(children[n]);
				}
			} else {
				panes = [panel];
			}
			for (n = 0; n < panes.length; n++) {
				pane = panes[n];
				isCurrent = pane === panel;
				if (isCurrent) {
					pane.classList.add('active');
					pane.classList.add('show');
				} else {
					pane.classList.remove('active');
					pane.classList.remove('show');
				}
			}
		};

		var activateShadowTab = function(root, trigger) {
			var locals = getArticleWindowLocals(root);
			var bootstrap = locals.bootstrap;
			if (bootstrap && bootstrap.Tab && typeof bootstrap.Tab.getOrCreateInstance === 'function') {
				try {
					bootstrap.Tab.getOrCreateInstance(trigger).show();
					return;
				} catch (err) {
					console.error('Shadow Bootstrap Tab failed:', err);
				}
			}
			activateShadowTabFallback(root, trigger);
		};

		var bindShadowBootstrapTabs = function(root) {
			if (!root.querySelector(tabToggleSelector) || boundTabShadowRoots.has(root)) return;
			boundTabShadowRoots.add(root);
			root.addEventListener('click', function(event) {
				var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
				var trigger = null;
				var n, node;
				for (n = 0; n < path.length; n++) {
					node = path[n];
					if (node && node.nodeType === 1 && node.matches && node.matches(tabToggleSelector)) {
						trigger = node;
						break;
					}
				}
				if (!trigger || !root.contains(trigger)) return;
				event.preventDefault();
				activateShadowTab(root, trigger);
			});
		};

		var extractDeclaredFunctionNames = function(code) {
			var names = [];
			var seen = {};
			var pattern = /(?:async\s+)?function\s+([A-Za-z_$][\w$]*)\s*\(/g;
			var match;
			while ((match = pattern.exec(code)) !== null) {
				if (!seen[match[1]]) {
					seen[match[1]] = true;
					names.push(match[1]);
				}
			}
			return names;
		};

		var alreadyFiredWindowEvents = {
			load: true,
			DOMContentLoaded: true,
			pageshow: true,
			readystatechange: true
		};

		var eventTypeFromOnProp = function(prop) {
			if (typeof prop !== 'string' || !/^on[a-z]/i.test(prop) || prop.length < 3) return null;
			var raw = prop.slice(2);
			if (/^domcontentloaded$/i.test(raw)) return 'DOMContentLoaded';
			return raw.toLowerCase();
		};

		var isAlreadyFiredWindowEvent = function(type) {
			return !!alreadyFiredWindowEvents[type];
		};

		var scheduleMicrotask = function(fn) {
			if (typeof queueMicrotask === 'function') queueMicrotask(fn);
			else setTimeout(fn, 0);
		};

		var createShadowDomBindings = function(root) {
			var documentProxy;
			var windowProxy;
			var windowOnHandlers = {};
			var windowLocals = getArticleWindowLocals(root);

			var getContentRoot = function() {
				return root.querySelector('.help-article-content') || root.host;
			};

			var emptyNodeList = function() {
				return root.querySelectorAll(':not(*)');
			};

			var queryOne = function(selector) {
				try {
					return root.querySelector(selector);
				} catch (e) {
					return null;
				}
			};

			var queryAll = function(selector) {
				try {
					return root.querySelectorAll(selector);
				} catch (e) {
					return emptyNodeList();
				}
			};

			var scheduleListener = function(listener, thisArg, type) {
				scheduleMicrotask(function() {
					try {
						var fn = typeof listener === 'function' ? listener : listener.handleEvent;
						fn.call(thisArg, new Event(type));
					} catch (err) {
						console.error('Shadow load handler failed:', err);
					}
				});
			};

			var documentOverrides = {
				readyState: 'complete',
				querySelector: queryOne,
				querySelectorAll: queryAll,
				getElementById: function(id) {
					return queryOne('#' + id);
				},
				getElementsByClassName: function(className) {
					return queryAll('.' + String(className).trim().split(/\s+/).join('.'));
				},
				getElementsByTagName: function(tag) {
					var lower = String(tag).toLowerCase();
					if (lower === 'body' || lower === 'html') return [getContentRoot()];
					return queryAll(tag);
				},
				addEventListener: function(type, listener, options) {
					if (isAlreadyFiredWindowEvent(type)) {
						scheduleListener(listener, documentProxy, type);
						return;
					}
					root.addEventListener(type, listener, options);
				},
				removeEventListener: function(type, listener, options) {
					root.removeEventListener(type, listener, options);
				},
				createElement: function() {
					return document.createElement.apply(document, arguments);
				},
				createElementNS: function() {
					return document.createElementNS.apply(document, arguments);
				},
				createTextNode: function(data) {
					return document.createTextNode(data);
				},
				createComment: function(data) {
					return document.createComment(data);
				},
				createDocumentFragment: function() {
					return document.createDocumentFragment();
				},
				contains: function(node) {
					return !!node && (root.contains(node) || getContentRoot().contains(node));
				}
			};

			documentProxy = new Proxy(document, {
				get: function(target, prop) {
					var value;
					if (prop === 'body' || prop === 'documentElement' || prop === 'scrollingElement') {
						return getContentRoot();
					}
					if (prop === 'defaultView') return windowProxy;
					if (typeof prop === 'string' && Object.prototype.hasOwnProperty.call(documentOverrides, prop)) {
						return documentOverrides[prop];
					}
					value = Reflect.get(target, prop, target);
					return typeof value === 'function' ? value.bind(target) : value;
				},
				set: function(target, prop, value) {
					return Reflect.set(target, prop, value, target);
				}
			});

			var windowOverrides = {
				addEventListener: function(type, listener, options) {
					if (isAlreadyFiredWindowEvent(type)) {
						scheduleListener(listener, windowProxy, type);
						return;
					}
					window.addEventListener(type, listener, options);
				},
				removeEventListener: function(type, listener, options) {
					if (isAlreadyFiredWindowEvent(type)) return;
					window.removeEventListener(type, listener, options);
				}
			};

			windowProxy = new Proxy(window, {
				get: function(target, prop) {
					var value;
					if (prop === 'document') return documentProxy;
					if (prop === 'window' || prop === 'self' || prop === 'globalThis' || prop === 'parent' || prop === 'top') {
						return windowProxy;
					}
					if (typeof prop === 'string' && Object.prototype.hasOwnProperty.call(windowOverrides, prop)) {
						return windowOverrides[prop];
					}
					if (typeof prop === 'string' && Object.prototype.hasOwnProperty.call(windowLocals, prop)) {
						return windowLocals[prop];
					}
					value = Reflect.get(target, prop, target);
					return typeof value === 'function' ? value.bind(target) : value;
				},
				set: function(target, prop, value) {
					var type, previous, wrapped;
					if (typeof prop !== 'string') return Reflect.set(target, prop, value, target);
					if (isolatedWindowKeys[prop]) {
						snapshotPageWindowGlobals();
						windowLocals[prop] = value;
						target[prop] = value;
						getArticleScriptScope(root)[prop] = value;
						return true;
					}

					type = eventTypeFromOnProp(prop);
					if (!type) return Reflect.set(target, prop, value, target);
					if (type === 'error') return Reflect.set(target, prop, value, target);

					previous = windowOnHandlers[type];
					if (previous) {
						window.removeEventListener(type, previous);
						delete windowOnHandlers[type];
					}

					if (
						typeof value !== 'function' &&
						(typeof value !== 'object' || value === null || typeof value.handleEvent !== 'function')
					) {
						return true;
					}

					if (isAlreadyFiredWindowEvent(type)) {
						scheduleListener(value, windowProxy, type);
						return true;
					}

					wrapped = function(event) {
						var fn = typeof value === 'function' ? value : value.handleEvent;
						fn.call(windowProxy, event);
					};
					windowOnHandlers[type] = wrapped;
					window.addEventListener(type, wrapped);
					return true;
				}
			});

			return { documentProxy: documentProxy, windowProxy: windowProxy };
		};

		var bindInlineEventHandlers = function(root) {
			var documentShim = createShadowDomBindings(root).documentProxy;
			var elements = root.querySelectorAll('*');
			var el, attrs, attr, type, handlerCode, j, k;

			for (j = 0; j < elements.length; j++) {
				el = elements[j];
				attrs = [];
				for (k = 0; k < el.attributes.length; k++) {
					attrs.push(el.attributes[k]);
				}
				for (k = 0; k < attrs.length; k++) {
					attr = attrs[k];
					if (!/^on[a-z]+$/i.test(attr.name)) continue;
					type = attr.name.slice(2).toLowerCase();
					handlerCode = attr.value;
					el.removeAttribute(attr.name);
					(function(target, eventType, code) {
						target.addEventListener(eventType, function(event) {
							var scope = getArticleScriptScope(root);
							var names = [];
							var values = [event, documentShim];
							var name, compiled, result;
							for (name in scope) {
								if (Object.prototype.hasOwnProperty.call(scope, name)) {
									names.push(name);
									values.push(scope[name]);
								}
							}
							try {
								compiled = Function.apply(null, ['event', 'document'].concat(names).concat([code]));
								result = compiled.apply(this, values);
								if (result === false) {
									event.preventDefault();
									event.stopPropagation();
								}
							} catch (err) {
								console.error('Shadow inline handler failed:', err);
							}
						});
					})(el, type, handlerCode);
				}
			}
		};

		var execInShadow = function(code, root) {
			var token = Math.random().toString(36).substring(2, 9);
			var rootKey = '__shadow_root_' + token;
			var scopeKey = '__shadow_scope_' + token;
			var docKey = '__shadow_doc_' + token;
			var winKey = '__shadow_win_' + token;
			var bindings = createShadowDomBindings(root);
			var names = extractDeclaredFunctionNames(code);
			var exportBlock = '';
			var n;
			var scriptEl = document.createElement('script');

			for (n = 0; n < names.length; n++) {
				exportBlock += 'if (typeof ' + names[n] + ' === "function") __articleScope["' + names[n] + '"] = ' + names[n] + ';';
			}

			window[rootKey] = root;
			window[scopeKey] = getArticleScriptScope(root);
			window[docKey] = bindings.documentProxy;
			window[winKey] = bindings.windowProxy;
			scriptEl.textContent =
				'(function(shadowRoot, __articleScope, document, window) {' +
				'if (!shadowRoot) return;' +
				'var globalThis = window;' +
				'var self = window;' +
				'var module = undefined;' +
				'var exports = undefined;' +
				'var define = undefined;' +
				'try {' +
				code +
				exportBlock +
				'} catch (err) { console.error("Shadow script failed:", err); }' +
				"}).call(window['" + winKey + "'], window['" + rootKey + "'], window['" + scopeKey + "'], window['" + docKey + "'], window['" + winKey + "']);" +
				"delete window['" + rootKey + "'];" +
				"delete window['" + scopeKey + "'];" +
				"delete window['" + docKey + "'];" +
				"delete window['" + winKey + "'];";
			document.body.appendChild(scriptEl);
		};

		var loadScriptTextXhr = function(url, onSuccess, onError) {
			var xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.onreadystatechange = function() {
				if (xhr.readyState != 4) return;
				if (xhr.status == 200) onSuccess(xhr.responseText);
				else {
					console.error('Shadow script load failed');
					if (onError) onError();
				}
			};
			xhr.onerror = function() {
				console.error('Shadow script load failed');
				if (onError) onError();
			};
			xhr.send();
		};

		var loadScriptText = function(url, onSuccess, onError) {
			if (typeof fetch !== 'function') {
				loadScriptTextXhr(url, onSuccess, onError);
				return;
			}
			fetch(url).then(function(res) {
				if (!res.ok) throw new Error('Shadow script load failed');
				return res.text();
			}).then(onSuccess).catch(function() {
				loadScriptTextXhr(url, onSuccess, onError);
			});
		};

		// Declarative Shadow DOM(SSR)이 있으면 재사용하고, 없으면 attachShadow.
		// JS on: textarea 원본으로 shadow 트리를 재구성(스크립트/스타일 hydrate).
		// JS off: 서버가 내려준 <template shadowrootmode="open"> 본문이 그대로 노출됨.
		if(!host || !source) return false;
		if(!host.shadowRoot && !host.attachShadow) return false;

		articleHtml = source.value;
		if(!articleHtml) return false;

		var closeHtml = articleHtml.toLowerCase().lastIndexOf('</html>');
		if(closeHtml !== -1) articleHtml = articleHtml.slice(0, closeHtml + 7);

		shadowRoot = host.shadowRoot || host.attachShadow({ mode: 'open' });
		parsedDoc = parseArticleHtmlDocument(articleHtml);

		while(shadowRoot.firstChild){
			shadowRoot.removeChild(shadowRoot.firstChild);
		}

		var articleContentStyle = document.createElement('style');
		articleContentStyle.textContent =
			':host { all:initial; display:block; width:100%; max-width:100%; min-width:0; box-sizing:border-box; }' +
			'.help-article-content { word-wrap:break-word; word-break:break-word; }' +
			'.help-article-content p { margin-top:.8rem; margin-bottom:.8rem; }';
		shadowRoot.appendChild(articleContentStyle);

		links = parsedDoc.querySelectorAll('link');
		for(i=0;i<links.length;i++) {
			var sourceLink = links[i];
			var linkEl = document.createElement('link');
			var href = sourceLink.getAttribute('href');
			var type = sourceLink.getAttribute('type');
			var media = sourceLink.getAttribute('media');
			var crossOrigin = sourceLink.getAttribute('crossorigin');
			linkEl.rel = sourceLink.rel || 'stylesheet';
			if(href) {
				linkEl.href = resolveResourceUrl(href);
				if (isFontStylesheetHref(href)) ensureDocumentFontStylesheet(href);
			}
			if(type) linkEl.type = type;
			if(media) linkEl.media = media;
			if(crossOrigin) linkEl.crossOrigin = crossOrigin;
			shadowRoot.appendChild(linkEl);
		}

		styles = parsedDoc.querySelectorAll('style');
		for(i=0;i<styles.length;i++) {
			var clonedStyle = document.importNode(styles[i], true);
			if(clonedStyle.textContent) clonedStyle.textContent = aliasBodySelectors(clonedStyle.textContent);
			shadowRoot.appendChild(clonedStyle);
		}

		bodyClone = document.importNode(parsedDoc.body, true);
		skipNodes = bodyClone.querySelectorAll('script, link, style');
		for(i=0;i<skipNodes.length;i++) {
			skipNodes[i].parentNode.removeChild(skipNodes[i]);
		}

		contentRoot = document.createElement('div');
		contentRoot.className = 'help-article-content';
		if(parsedDoc.body.className) contentRoot.className = contentRoot.className + ' ' + parsedDoc.body.className;
		if(parsedDoc.body.getAttribute('style')) contentRoot.setAttribute('style', parsedDoc.body.getAttribute('style'));
		if(document.documentElement.getAttribute('dir') == 'rtl') contentRoot.setAttribute('dir', 'rtl');
		contentRoot.setAttribute('data-bs-no-jquery', '');
		while(bodyClone.firstChild){
			contentRoot.appendChild(bodyClone.firstChild);
		}
		shadowRoot.appendChild(contentRoot);

		scripts = parsedDoc.querySelectorAll('script');
		var runArticleScripts = function(index) {
			var oldScript, src, inlineCode;
			if (index >= scripts.length) {
				bindInlineEventHandlers(shadowRoot);
				bindShadowBootstrapTabs(shadowRoot);
				restorePageWindowGlobals();
				return;
			}

			oldScript = scripts[index];
			src = oldScript.getAttribute('src') || '';
			if (src.indexOf(wrongJs) != -1) {
				runArticleScripts(index + 1);
				return;
			}
			if (src && isFontAwesomeScriptSrc(src)) {
				loadFontAwesomeScript(
					src,
					function() {
						syncFontAwesomeStylesIntoShadow(shadowRoot);
						runArticleScripts(index + 1);
					},
					function() {
						runArticleScripts(index + 1);
					}
				);
				return;
			}
			if (src) {
				loadScriptText(
					resolveResourceUrl(src),
					function(code) {
						try {
							execInShadow(code, shadowRoot);
						} catch (err) {
							console.error('Shadow script load failed:', err);
						}
						runArticleScripts(index + 1);
					},
					function() {
						runArticleScripts(index + 1);
					}
				);
				return;
			}
			inlineCode = oldScript.textContent || oldScript.innerHTML;
			if (inlineCode) {
				try {
					execInShadow(inlineCode, shadowRoot);
				} catch (err) {
					console.error('Shadow inline script failed:', err);
				}
			}
			runArticleScripts(index + 1);
		};
		runArticleScripts(0);

		anchors = shadowRoot.querySelectorAll('a');
		for(i=0;i<anchors.length;i++) {
			var target = anchors[i].getAttribute('target');
			if(!target || target == '_parent') anchors[i].setAttribute('target', '_top');
		}
	};

	initGscsArticleShadow();
})();
